import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@linkhr/i18n";
import { rowForPath, rowLabelKey } from "../nav";
import { usePrototype } from "../prototype/store";
import { AccountantOnlyScreen } from "../shell/AccountantOnlyScreen";
import { ComingSoonScreen } from "../shell/ComingSoonScreen";

/** Every menu row whose screen has not been built yet lands here. */
export const Route = createFileRoute("/prototype/c/$companyId/$")({
  component: NotBuiltYet,
});

function NotBuiltYet() {
  const { _splat } = Route.useParams();
  const { t } = useTranslation("accounting");
  const { state } = usePrototype();
  const row = rowForPath(_splat ?? "");

  if (row?.accountantOnly === true && state.mode === "owner") {
    return <AccountantOnlyScreen title={t(rowLabelKey(row, "accountant"))} />;
  }
  return (
    <ComingSoonScreen
      title={t(row === undefined ? "accounting:coming_soon.title" : rowLabelKey(row, state.mode))}
    />
  );
}
